// extracted by mini-css-extract-plugin
module.exports = {"eulaSection":"EulaFormSection-eulaSection_097bea4c","eulaAccept":"EulaFormSection-eulaAccept_0c84f732","details":"EulaFormSection-details_9c2050e5"};